import { render, staticRenderFns } from "./NewCriterio.vue?vue&type=template&id=63415b50&scoped=true"
import script from "./NewCriterio.vue?vue&type=script&lang=js"
export * from "./NewCriterio.vue?vue&type=script&lang=js"
import style0 from "./NewCriterio.vue?vue&type=style&index=0&id=63415b50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63415b50",
  null
  
)

export default component.exports